import { createContext } from 'react';
import { ContextInterface, TranslationDataType } from './types';

export const LOCALE_EN_US: AppLocaleType = 'en-us';
export const LOCALE_RU_RU: AppLocaleType = 'ru-ru';
export const LOCALE_HY_AM: AppLocaleType = 'hy-am';
export const defaultLanguage = LOCALE_EN_US;

const TranslationContext = createContext<ContextInterface>({
  locales: [],
  locale: LOCALE_EN_US,

  setLocale: (_locale: AppLocaleType): void => {},
  t: (_key: string, _data: TranslationDataType = {}): string => '',
  translate: (
    _locale: AppLocaleType,
    _key: string,
    _data: TranslationDataType = {},
  ): string => '',
});

export default TranslationContext;
